import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getAdminCredits = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/credits/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Admin credits fetch error:", error);
    throw error;
  }
};

const getCompanyCreditDetails = async (companyId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/credits/?company_id=${companyId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Company credit details fetch error:", error);
    throw error;
  }
};

const getCompanyModulesLookup = async (companyId) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/modules/lookup/?company_id=${companyId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Company modules lookup fetch error:", error);
    throw error;
  }
};

const submitCreditAdjustment = async (companyId, data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/credits/adjustments/?company_id=${companyId}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Credit adjustment submit error:", error);
    throw error;
  }
};

export {
  getAdminCredits,
  getCompanyCreditDetails,
  getCompanyModulesLookup,
  submitCreditAdjustment,
};
